import { render } from "./SuscripcionAud.vue?vue&type=template&id=7b2ba157"
import script from "./SuscripcionAud.vue?vue&type=script&lang=js"
export * from "./SuscripcionAud.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__